import {FilterType, IGameFilter} from './game-filter.interface';
import {GameInfo} from '../../games/game-info';
import {ActiveFilter} from '../games-filter.service.interface';
import { Check } from '@sparkware/app-utils';

export class SubgroupNameFilter implements IGameFilter {
  constructor(private _subGroupName: string) {

  }
  get filterType(): FilterType {
    return FilterType.categoryFilter;
  }

  applyFilter(gameInfo: GameInfo, currentActiveFilters: ActiveFilter[]): boolean {
    if(Check.isNullOrUndefined(gameInfo.subGroupName)){
      return false;
    }

    return gameInfo.subGroupName.toLowerCase().indexOf(this._subGroupName) !== -1;
  }
}
